import React, { useEffect, useState } from "react";
import SideMenu from "../sideMenu";
import { Loader } from "../loader";
import {
  CustomText,
  CustomTextArea,
  PrimaryCta,
  PrimaryCtaInvert,
  ModalComponent,
} from "../../components";
import Utils from "../../common/utils";
import {
  buildInvoicePreviewCandidates,
  resolveFirstInvoicePreview,
  revokeInvoicePreviewUrl,
} from "../../common/invoicePreview";
import Theme from "../../resources/themes/light";
import Core from "../../common/clientSdk";
import { useSnackbar } from "react-simple-snackbar";
import Header from "../header";
import Icon from "../../components/core_component/icon";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Modal from "react-modal";
import InvoiceDownloadModal from "../../components/InvoiceDownloadModal";
import { BRIDGENESS_ADDRESS } from "../../common/payoutInvoiceUtils";
import { usePayoutInvoiceDownload } from "../../common/usePayoutInvoiceDownload";
import "../../components/InvoiceDownloadModal.css";
import "./payoutDetailScreen.css";

function PayoutDetailScreen(props) {
  const [isLoading, setLoading] = useState(false);
  const [kycData, setKycData] = useState([]);
  const [influencerData, setInfluencerData] = useState();
  const [contractData, setContractData] = useState({});
  const [campaignData, setCampaignData] = useState({});
  const [payoutListData, setPayOutListData] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [effectiveLoad, setEffectiveLoad] = useState(false);
  const [isPayoutCompleted, setIsPayoutCompleted] = useState();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [rejectModalIsOpen, setRejectModalIsOpen] = useState(false);
  const [payout_id, setPayoutId] = useState(props.item);
  const [rejectPayoutLoading, setRejectPayoutLoading] = useState(false);
  const [invoicePreviewOpen, setInvoicePreviewOpen] = useState(false);
  const [showInvoiceRejectReason, setShowInvoiceRejectReason] = useState(false);
  const [invoiceRejectionReason, setInvoiceRejectionReason] = useState("");
  const [invoiceReviewLoading, setInvoiceReviewLoading] = useState(false);
  const [invoicePreview, setInvoicePreview] = useState(null);
  const [invoicePreviewLoading, setInvoicePreviewLoading] = useState(false);
  const [invoicePreviewError, setInvoicePreviewError] = useState("");
  const [pdfFrameReady, setPdfFrameReady] = useState(false);
  const [generateInvoiceLoading, setGenerateInvoiceLoading] = useState(false);

  const {
    downloading: invoiceDownloading,
    downloadModalVisible,
    customInvoiceId,
    setCustomInvoiceId,
    autoGeneratedInvoiceId,
    existingInvoiceNumber,
    openDownloadModal,
    closeDownloadModal,
    handleDownloadWithExisting,
    handleDownloadWithAutoGenerated,
    handleDownloadWithCustom,
    initializeInvoiceNumberFromPayout,
  } = usePayoutInvoiceDownload({
    payoutData: payoutListData,
    payoutToken:
      payoutListData?.payout_token ||
      props.payout_token ||
      null,
    assignmentName: contractData?.name,
    assignmentId: contractData?.assignment_id,
    onError: (message) => toast.error(message),
    onInvoiceNumberSaved: (invoiceNumber) => {
      setPayOutListData((prev) =>
        prev
          ? {
              ...prev,
              invoice_number: invoiceNumber,
              invoice_id: invoiceNumber,
            }
          : prev
      );
    },
  });

  // const [initiateTransferClicked, setInitiateTransferClicked] = useState(false);

  const navigate = useNavigate();

  const [openSnackbar] = useSnackbar();

  function updateProgress(status) {
    setLoading(status);
  }

  useEffect(() => {
    payoutDetailsAdmin(updateProgress);
  }, []);

  useEffect(() => {
    if (payoutListData) {
      setIsPayoutCompleted(payoutListData?.status);
    }
  }, [payoutListData]);

  //  -------------- Api calls -------------------

  const payoutDetailsAdmin = () => {
    const params = { payout_id: payout_id };
    Core.payoutAdminDetails(
      payoutDetailsAdminSuccess,
      payoutDetailsAdminFailed,
      updateProgress,
      params,
    );
  };

  const payoutDetailsAdminSuccess = (response) => {
    console.log("response", response);
    const payoutDetails = response.payout_details || {};
    const nextPayoutData = {
      ...payoutDetails,
      payout_token:
        payoutDetails.payout_token || props.payout_token || null,
      payout_token_expiry:
        payoutDetails.payout_token_expiry || props.payout_token_expiry || null,
    };
    setPayOutListData(nextPayoutData);
    initializeInvoiceNumberFromPayout(nextPayoutData);
    getInfluencerDetailAdmin(payoutDetails.influencer_id);
    assignmentAdminDetails(payoutDetails.assignment_id);
  };

  const payoutDetailsAdminFailed = (errorList) => {
    openSnackbar(errorList.map((item) => item.m).join(", "));
  };

  console.log("payoutListData", payoutListData);

  function getInfluencerDetailAdmin(influencer_id) {
    var params = {
      influencer_id: influencer_id,
    };
    Core.getInfluencerAdminDetail(
      getInfluencerDetailAdminSuccess,
      getInfluencerDetailAdminFailed,
      updateProgress,
      params,
    );
  }

  function getInfluencerDetailAdminSuccess(response) {
    console.log("inf res", response);
    setInfluencerData(response.influencer_deep_data || []);
    setKycData(response.influencer_deep_data.kyc_data || []);
    setLoading(false);
  }
  console.log("influencer ", influencerData);

  function getInfluencerDetailAdminFailed(errorList) {
    openSnackbar(errorList.map((item) => item.m).join(", "));
  }

  function assignmentAdminDetails(assignment_id) {
    const params = {
      assignment_id: assignment_id,
    };
    Core.assignmentAdminDetails(
      assignmentAdminDetailsSuccess,
      assignmentAdminDetailsFailed,
      updateProgress,
      params,
    );
  }

  function assignmentAdminDetailsSuccess(response_data) {
    setContractData(response_data.assignment_deep_data.assignment_data || []);
    setCampaignData(response_data?.assignment_deep_data?.campaign_data);
  }

  function assignmentAdminDetailsFailed(errorList) {
    openSnackbar(errorList.map((item) => item.m).join(", "));
  }
  function payoutCompleteMarkAdmin() {
    const params = {
      payout_id: payout_id,
    };
    Core.payoutCompleteMarkAdmin(
      payoutCompleteMarkAdminSuccess,
      payoutCompleteMarkAdminFailed,
      updateProgress,
      params,
    );
  }

  function payoutCompleteMarkAdminSuccess() {
    toast.success("Payout marked as completed!");
    closeModal();
    if (props.onActionComplete) {
      props.onActionComplete(); // This will refresh the parent list
    }
  }

  function payoutCompleteMarkAdminFailed(errorList) {
    openSnackbar(errorList.map((item) => item.m).join(", "));
    closeModal();
  }

  const openRejectModal = () => {
    setRejectModalIsOpen(true);
  };

  const closeRejectModal = () => {
    setRejectModalIsOpen(false);
  };

  function rejectPayout() {
    let params = {
      payout_id: payout_id,
    };
    Core.rejectPayout(
      rejectPayoutSuccess,
      rejectPayoutFailed,
      (status) => setRejectPayoutLoading(status),
      params,
    );
  }

  function rejectPayoutSuccess(response) {
    toast.success("Payout rejected successfully");
    setRejectPayoutLoading(false);
    closeRejectModal();
    if (props.onActionComplete) {
      props.onActionComplete(); // This will refresh the parent list
    }
  }

  function rejectPayoutFailed(errorList) {
    setRejectPayoutLoading(false);
    closeRejectModal();
    if (Array.isArray(errorList)) {
      toast.error(errorList.map((item) => item.m).join(", "));
    } else {
      toast.error(errorList || "Failed to reject payout");
    }
  }

  const invoiceStatus = payoutListData?.invoice_status;
  const resolvedPayoutToken =
    payoutListData?.payout_token || props.payout_token || null;

  function isPayoutTokenValid(token, expiryValue) {
    if (!token) {
      return false;
    }
    const expiryRaw = Number(expiryValue);
    if (!Number.isFinite(expiryRaw) || expiryRaw <= 0) {
      return true;
    }
    const expiryMs = expiryRaw < 1e12 ? expiryRaw * 1000 : expiryRaw;
    return expiryMs > Date.now();
  }

  const hasValidPayoutToken = isPayoutTokenValid(
    resolvedPayoutToken,
    payoutListData?.payout_token_expiry || props.payout_token_expiry
  );
  const hasPayoutToken = Boolean(
    hasValidPayoutToken ||
      resolvedPayoutToken ||
      payoutListData?.payout_token_expiry ||
      props.payout_token_expiry
  );
  const isInvoiceUploaded =
    invoiceStatus === "SUBMITTED" ||
    invoiceStatus === "APPROVED" ||
    invoiceStatus === "ACCEPTED";
  const canDownloadInvoice = Boolean(
    hasValidPayoutToken &&
      payoutListData?.payout_id &&
      !isInvoiceUploaded
  );
  const isAwaitingInvoice =
    invoiceStatus === "PENDING" || invoiceStatus === "REJECTED";
  const isInvoiceBlockingActions =
    invoiceStatus === "SUBMITTED" || isAwaitingInvoice;
  const invoiceUrl = Utils.generatePayoutInvoiceUrl(
    payoutListData?.payout_id || payout_id,
    payoutListData?.invoice_media_id
  );

  useEffect(() => {
    if (!payoutListData?.invoice_media_id) {
      setInvoicePreview(null);
      setInvoicePreviewError("");
      return undefined;
    }

    let cancelled = false;
    let previewUrl = "";

    setInvoicePreviewLoading(true);
    setInvoicePreviewError("");

    resolveFirstInvoicePreview(
      buildInvoicePreviewCandidates(payoutListData, payout_id)
    )
      .then((preview) => {
        if (cancelled) {
          revokeInvoicePreviewUrl(preview?.url);
          return;
        }
        previewUrl = preview.url;
        setPdfFrameReady(false);
        setInvoicePreview(preview);
      })
      .catch(() => {
        if (cancelled) {
          return;
        }
        setInvoicePreview(null);
        setInvoicePreviewError("Unable to load invoice preview");
      })
      .finally(() => {
        if (!cancelled) {
          setInvoicePreviewLoading(false);
        }
      });

    return () => {
      cancelled = true;
      revokeInvoicePreviewUrl(previewUrl);
    };
  }, [payoutListData?.invoice_media_id, payoutListData?.payout_id, payout_id]);

  useEffect(() => {
    if (
      !invoicePreview?.url ||
      invoicePreview.kind !== "pdf" ||
      pdfFrameReady
    ) {
      return undefined;
    }
    const timer = window.setTimeout(() => setPdfFrameReady(true), 10000);
    return () => window.clearTimeout(timer);
  }, [invoicePreview?.url, invoicePreview?.kind, pdfFrameReady]);

  const openInvoicePreview = (options = {}) => {
    const showRejectForm = Boolean(options.reject);
    setShowInvoiceRejectReason(showRejectForm);
    if (!showRejectForm) {
      setInvoiceRejectionReason("");
    }
    setInvoicePreviewOpen(true);
  };

  const closeInvoicePreview = () => {
    setInvoicePreviewOpen(false);
    setShowInvoiceRejectReason(false);
    setInvoiceRejectionReason("");
  };

  function reviewPayoutInvoice(action) {
    const params = {
      payout_id: payout_id,
      action: action,
      rejection_reason:
        action === "REJECT" ? invoiceRejectionReason.trim() : "",
    };
    Core.reviewPayoutInvoice(
      reviewPayoutInvoiceSuccess,
      reviewPayoutInvoiceFailed,
      (status) => setInvoiceReviewLoading(status),
      params
    );
  }

  function reviewPayoutInvoiceSuccess() {
    toast.success(
      showInvoiceRejectReason
        ? "Invoice rejected successfully"
        : "Invoice approved successfully"
    );
    closeInvoicePreview();
    payoutDetailsAdmin();
    if (props.onActionComplete) {
      props.onActionComplete();
    }
  }

  function reviewPayoutInvoiceFailed(errorList) {
    if (Array.isArray(errorList)) {
      toast.error(errorList.map((item) => item.m).join(", "));
    } else {
      toast.error(errorList || "Failed to review invoice");
    }
  }

  const handleApproveInvoice = () => {
    reviewPayoutInvoice("APPROVED");
  };

  const handleSubmitInvoiceRejection = () => {
    if (!invoiceRejectionReason.trim()) {
      toast.error("Please enter a rejection reason");
      return;
    }
    reviewPayoutInvoice("REJECT");
  };

  function generatePayoutToken() {
    Core.generatePayoutToken(
      generatePayoutTokenSuccess,
      generatePayoutTokenFailed,
      (status) => setGenerateInvoiceLoading(status),
      { payout_id: payout_id }
    );
  }

  function generatePayoutTokenSuccess() {
    toast.success("Invoice generated successfully");
    payoutDetailsAdmin();
    if (props.onActionComplete) {
      props.onActionComplete();
    }
  }

  function generatePayoutTokenFailed(errorList) {
    if (Array.isArray(errorList)) {
      toast.error(errorList.map((item) => item.m).join(", "));
    } else {
      toast.error(errorList || "Failed to generate invoice");
    }
  }

  const assignment_id = contractData?.assignment_id;

  // Core.payoutAdminInitiateTransfer   --------- [ For Button Api ] call it

  const toggleModal = () => {
    setOpenModal((prevState) => !prevState);
  };

  const handleInitateTransfer = () => {
    const params = { payout_id: payout_id };
    Core.payoutAdminInitiateTransfer(
      hanldeInitiateTranferSuccess,
      handleInitiateTransferFailed,
      (status) => setEffectiveLoad(status),
      params,
    );
  };

  function hanldeInitiateTranferSuccess(response_data) {
    console.log("transfer", response_data);
    setOpenModal(false);
    setEffectiveLoad(false);
    toast.success("Transfer initiated successfully!");
    payoutDetailsAdmin();
    if (props.onActionComplete) {
      props.onActionComplete(); // This will refresh the parent list
    }
  }

  function handleInitiateTransferFailed(errorList) {
    openSnackbar(errorList?.map((item) => item?.m).join(", "));
    setOpenModal(false);
  }

  function contactDetailPage(assignment_id) {
    window.open(`/contractDetail/${assignment_id}`, "_blank");
  }

  const toFixedTwo = (value) => Number(value).toFixed(1);

  const formatCurrency = (value) =>
    value != null ? `₹ ${toFixedTwo(value)}` : "N/A";

  const getStatusChipClass = (status) => {
    const normalized = String(status || "").toUpperCase();
    if (normalized === "COMPLETED" || normalized === "PAID") {
      return "payout-detail__chip payout-detail__chip--completed";
    }
    if (normalized === "PENDING") {
      return "payout-detail__chip payout-detail__chip--pending";
    }
    if (normalized === "PAYMENT_INITIATED") {
      return "payout-detail__chip payout-detail__chip--initiated";
    }
    if (normalized === "REJECTED") {
      return "payout-detail__chip payout-detail__chip--rejected";
    }
    if (normalized === "SUBMITTED" || normalized === "APPROVED" || normalized === "ACCEPTED") {
      return "payout-detail__chip payout-detail__chip--submitted";
    }
    if (normalized === "DRAFT") {
      return "payout-detail__chip payout-detail__chip--draft";
    }
    return "payout-detail__chip payout-detail__chip--draft";
  };

  const renderStatusChip = (status, label) => {
    const display =
      label ||
      (String(status || "").toUpperCase() === "COMPLETED" ? "Paid" : status);
    if (!display) return null;
    return <span className={getStatusChipClass(status)}>{display}</span>;
  };

  const renderField = (label, value, options = {}) => (
    <div className="payout-detail__field" key={label}>
      <span className="payout-detail__field-label">{label}</span>
      <span
        className={`payout-detail__field-value${
          options.mono ? " payout-detail__field-value--mono" : ""
        }`}
      >
        {value || "N/A"}
      </span>
    </div>
  );

  const renderSummaryItem = (label, value) => renderField(label, value);

  function withHiddenPdfToolbar(url) {
    if (!url) return url;
    const params = "toolbar=0&navpanes=0&scrollbar=1";
    if (String(url).includes("#")) {
      return `${url}&${params}`;
    }
    return `${url}#${params}`;
  }

  const renderPayoutAddressBlock = (title) => (
    <div className="payout-detail__address-card">
      <div className="payout-detail__section-title">{title}</div>
      <div className="payout-detail__field-value">{BRIDGENESS_ADDRESS.company}</div>
      {BRIDGENESS_ADDRESS.lines.map((line) => (
        <div key={`${title}-${line}`} className="payout-detail__field-label">
          {line}
        </div>
      ))}
      <div className="payout-detail__field-value" style={{ marginTop: 4, fontSize: 12 }}>
        {BRIDGENESS_ADDRESS.gstin}
      </div>
    </div>
  );

  function renderBankDetails() {
    if (!influencerData.influencer_data?.is_bank_verified) {
      return (
        <div className="p-l-12 m-t-12" style={{ flex: 1 }}>
          <CustomText
            p
            text={"Bank is not verified."}
            fontSize={"font_size_large"}
            textColor={"text_color_primary"}
            fontWeight={"Poppins_regular_large"}
            textAlign={"text_align_left"}
          />
        </div>
      );
    } else {
      return (
        <div className=" m-t-12" style={{ flex: 1 }}>
          <div className="engagement-view-inner ">
            <div className="instagram-data-view">
              <div>
                <div className="Kycdetails">
                  <div className="KycLeft">
                    <ul>
                      <li>
                        <h6>Influencer Id:</h6>
                        <span>
                          {influencerData.influencer_data?.influencer_id ||
                            "N/A"}
                        </span>
                      </li>
                      <li>
                        <h6>Account Holder:</h6>
                        <span>
                          {influencerData.bank_data?.account_holder || "N/A"}
                        </span>
                      </li>
                      <li>
                        <h6>Bank Name:</h6>
                        <span>
                          {" "}
                          {influencerData.bank_data?.bank_name || "N/A"}{" "}
                        </span>
                      </li>
                      <li>
                        <h6>Account Number:</h6>
                        <span>
                          {" "}
                          {influencerData.bank_data?.account_number ||
                            "N/A"}{" "}
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="KycRight">
                    <ul>
                      <li>
                        <h6>IFSC Code:</h6>
                        <span>
                          {influencerData.bank_data?.ifsc_code || "N/A"}
                        </span>
                      </li>
                      <li>
                        <h6>PAN:</h6>
                        <span>
                          {influencerData.kyc_data?.find(
                            (k) => k.kyc_id_type === "PAN",
                          )?.kyc_value || "N/A"}
                        </span>
                      </li>
                      <li>
                        <h6>GST:</h6>
                        <span>
                          {influencerData.kyc_data?.find(
                            (k) => k.kyc_type === "GST",
                          )?.kyc_value || "N/A"}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
  // function renderPayoutDetails() {
  //   if (!payoutListData) {
  //     return (
  //       <div className=" p-b-12 m-t-12">
  //         <CustomText
  //           p
  //           text={"Payout Details are not available."}
  //           fontSize={"font_size_large"}
  //           textColor={"text_color_primary"}
  //           fontWeight={"Poppins_regular_large"}
  //           textAlign={"text_align_left"}
  //         />
  //       </div>
  //     );
  //   } else {
  //     return (
  //       <div>
  //         <div className="Kycdetails">
  //           <div className="KycLeft">
  //             <ul>
  //               <li>
  //                 <h6>Completed Date :</h6>
  //                 <span>
  //                   {" "}
  //                   {Utils.formatDate(payoutListData?.date_completed || "N/A")}
  //                 </span>
  //               </li>

  //               <li>
  //                 <h6>Schedule Date :</h6>
  //                 <span>
  //                   {Utils.formatDate(payoutListData?.date_scheduled || "N/A")}
  //                 </span>
  //               </li>
  //               <li>
  //                 <h6> Status :</h6>
  //                 <span>{payoutListData?.status || "N/A"}</span>
  //               </li>
  //             </ul>
  //           </div>
  //           <div className="KycRight">
  //             <ul>
  //               <li>
  //                 <h6>Platform Charges :</h6>
  //                 <span>{payoutListData?.platform_charges || "N/A"}</span>
  //               </li>
  //               <li>
  //                 <h6>Order Amount :</h6>
  //                 <span>
  //                   {toFixedTwo(payoutListData?.order_amount) || "N/A"}
  //                 </span>
  //               </li>
  //               <li>
  //                 <h6>Tax Amount :</h6>
  //                 <span>
  //                   {" "}
  //                   {toFixedTwo(payoutListData?.tax_amount) || "N/A"}{" "}
  //                 </span>
  //               </li>
  //               <li>
  //                 <h6> Pay Amount :</h6>
  //                 <span>
  //                   {" "}
  //                   {toFixedTwo(payoutListData?.payout_amount) || "N/A"}{" "}
  //                 </span>
  //               </li>
  //             </ul>
  //           </div>
  //         </div>
  //       </div>
  //     );
  //   }
  // }
  function renderContractDetails() {
    if (!contractData) {
      return (
        <div className=" p-l-12 m-t-12" style={{ flex: 1, alignItems: "left" }}>
          <CustomText
            p
            text={"Contract Details are not available."}
            fontSize={"font_size_large"}
            textColor={"text_color_primary"}
            fontWeight={"Poppins_regular_large"}
            textAlign={"text_align_left"}
          />
        </div>
      );
    } else {
      return (
        <div style={{ flex: 1, alignItems: "left" }}>
          <div className="Kycdetails">
            <div className="KycLeft">
              <ul>
                <li>
                  <h6>Name :</h6>
                  <span>{contractData?.name || "N/A"}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      );
    }
  }

  const openModalFun = () => {
    if (modalIsOpen == false) {
      setModalIsOpen(true);
    } else {
      setModalIsOpen(false);
    }
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  function renderRejectPayoutModal() {
    return (
      <Modal
        isOpen={rejectModalIsOpen}
        onRequestClose={closeRejectModal}
        style={CancelReminder}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            background: "#ffffff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 54,
          }}
        >
          <div onClick={closeRejectModal} className="close-btn-icon">
            <Icon iconName="CloseRoundButtonIcon" />
          </div>

          <CustomText
            p
            text={"Reject Payout"}
            textColor={"text_color_primary"}
            fontSize={"font_size_2xl"}
            className="typographyH7"
          />
        </div>
        <div className="create-assignment-container">
          <CustomText
            p
            fontSize={"font_size_medium"}
            textColor={"text_color_primary"}
            text={
              "Are you sure you want to reject this payout? This action cannot be undone."
            }
            noOfLine="2"
            className={"two-line-text"}
          />
        </div>
        <div className="create-assignment-container">
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              paddingTop: 20,
            }}
          >
            <div className="">
              <PrimaryCta
                invertSmall
                onClick={closeRejectModal}
                fontSize={"font_size_large"}
                text={"Cancel"}
              />
            </div>

            <div className=" m-l-32">
              <PrimaryCta
                fifth
                onClick={() => rejectPayout()}
                fontSize={"font_size_large"}
                text={"Reject Payout"}
                isLoading={rejectPayoutLoading}
              />
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  function renderAssignmentSignModal() {
    return (
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={CancelReminder}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            background: "#ffffff",

            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 54,
          }}
        >
          <div onClick={closeModal} className="close-btn-icon">
            <Icon iconName="CloseRoundButtonIcon" />
          </div>

          <CustomText
            p
            text={"Payout Completed"}
            textColor={"text_color_primary"}
            fontSize={"font_size_2xl"}
            className="typographyH7"
          />
        </div>
        <div className="create-assignment-container">
          <CustomText
            p
            fontSize={"font_size_medium"}
            textColor={"text_color_primary"}
            text={
              "Are you sure to mark this payout COMPLETED. This action can not be undo,"
            }
            noOfLine="2"
            className={"two-line-text"}
          />
        </div>
        <div className="create-assignment-container">
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              paddingTop: 20,
            }}
          >
            {/* <button
              style={{ color: "#090a14" }}
              className="confirm-btn-bid "
              onClick={closeModal}
            >
              Close
            </button> */}

            <div className="">
              <PrimaryCta
                invertSmall
                onClick={closeModal}
                fontSize={"font_size_large"}
                text={"Close"}
              />
            </div>
            <div className=" m-l-32">
              <PrimaryCta
                fifth
                onClick={() => payoutCompleteMarkAdmin()}
                fontSize={"font_size_large"}
                text={"Mark Completed"}
                isLoading={isLoading}
                //   disabled={!collectionId}
              />
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  function renderInvoicePreviewModal() {
    const invoiceNumber =
      payoutListData?.invoice_number || existingInvoiceNumber || "";

    return (
      <ModalComponent
        isOpen={invoicePreviewOpen}
        onRequestClose={closeInvoicePreview}
        customStyle={{
          overlay: {
            backgroundColor: "rgba(15, 23, 42, 0.55)",
            zIndex: 999999,
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            backgroundColor: "#FFFFFF",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            padding: 0,
            border: "none",
            borderRadius: "12px",
            boxShadow: "0 20px 50px rgba(15, 23, 42, 0.2)",
            width: "min(920px, 94vw)",
            height: "min(88vh, 900px)",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <div className="invoice-preview-modal">
          <div className="invoice-preview-modal__header">
            <div>
              <h3 className="invoice-preview-modal__title">Invoice preview</h3>
              {invoiceNumber ? (
                <p className="invoice-preview-modal__subtitle">
                  Invoice number {invoiceNumber}
                </p>
              ) : (
                <p className="invoice-preview-modal__subtitle">
                  Review the uploaded invoice before accepting or rejecting
                </p>
              )}
            </div>
            <button
              type="button"
              className="invoice-preview-modal__close"
              onClick={closeInvoicePreview}
              aria-label="Close invoice preview"
            >
              <Icon iconName="CloseRoundButtonIcon" />
            </button>
          </div>

          <div className="invoice-preview-modal__body">
            {!invoiceUrl ? (
              <div className="invoice-preview-modal__empty">
                <CustomText
                  p
                  text={"Invoice file not available"}
                  fontSize={"font_size_medium"}
                  textColor={"text_grey_400_color"}
                />
              </div>
            ) : invoicePreviewLoading ? (
              <div className="payout-detail__pdf-loader payout-detail__pdf-loader--static">
                <Loader />
                <CustomText
                  p
                  text={"Loading invoice..."}
                  fontSize={"font_size_medium"}
                  textColor={"text_grey_400_color"}
                  className="m-t-12"
                />
              </div>
            ) : !invoicePreview ? (
              <div className="invoice-preview-modal__empty">
                <CustomText
                  p
                  text={invoicePreviewError || "Invoice preview not available"}
                  fontSize={"font_size_medium"}
                  textColor={"text_grey_400_color"}
                />
                <div className="m-t-12">
                  <PrimaryCta
                    invertSmall
                    fontSize={"font_size_regular"}
                    text={"Open invoice file"}
                    onClick={() => window.open(invoiceUrl, "_blank")}
                  />
                </div>
              </div>
            ) : invoicePreview.kind === "image" ? (
              <img
                src={invoicePreview.url}
                alt="Payout invoice"
                className="invoice-preview-modal__image"
              />
            ) : (
              <div className="payout-detail__pdf-frame payout-detail__pdf-frame--modal">
                <iframe
                  key={invoicePreview.url}
                  title="Payout invoice"
                  src={withHiddenPdfToolbar(invoicePreview.url)}
                  onLoad={() => setPdfFrameReady(true)}
                  onError={() => setPdfFrameReady(true)}
                />
                {!pdfFrameReady && (
                  <div className="payout-detail__pdf-loader">
                    <Loader />
                    <CustomText
                      p
                      text={"Loading invoice..."}
                      fontSize={"font_size_medium"}
                      textColor={"text_grey_400_color"}
                      className="m-t-12"
                    />
                  </div>
                )}
              </div>
            )}
          </div>

          {showInvoiceRejectReason && (
            <div className="invoice-preview-modal__reject">
              <CustomText
                p
                text={"Rejection reason"}
                fontSize={"font_size_medium"}
                textColor={"text_color_primary"}
                className="m-b-8"
              />
              <CustomTextArea
                invert
                className="custom-text-offer"
                rows={4}
                placeholder="Write the reason for rejecting this invoice"
                value={invoiceRejectionReason}
                onChange={(e) => setInvoiceRejectionReason(e.target.value)}
              />
            </div>
          )}

          <div className="invoice-preview-modal__footer">
            {showInvoiceRejectReason ? (
              <>
                <PrimaryCta
                  invertSmall
                  onClick={() => {
                    setShowInvoiceRejectReason(false);
                    setInvoiceRejectionReason("");
                  }}
                  fontSize={"font_size_large"}
                  text={"Back"}
                />
                <PrimaryCta
                  fifth
                  fontSize={"font_size_regular"}
                  text={"Submit"}
                  isLoading={invoiceReviewLoading}
                  onClick={handleSubmitInvoiceRejection}
                />
              </>
            ) : (
              <>
                <PrimaryCtaInvert
                  borderColor="var(--general-error)"
                  fontSize="font_size_regular"
                  height="40px"
                  text="Reject"
                  onClick={() => setShowInvoiceRejectReason(true)}
                />
                <PrimaryCta
                  fifth
                  fontSize={"font_size_regular"}
                  text={"Approve"}
                  isLoading={invoiceReviewLoading}
                  onClick={handleApproveInvoice}
                />
              </>
            )}
          </div>
        </div>
      </ModalComponent>
    );
  }

  return (
    <div className="dashboard-container">
      {/* <SideMenu /> */}
      <div className="" style={{ width: "100%" }}>
        {/* <Header /> */}
        <div className="m-t-20 m-b-20" style={{ width: "100%" }}>
          {isLoading ? (
            props.isEmbedded ? (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "16px 0",
                }}
              >
                <Loader />
              </div>
            ) : (
              <div className="loader-mid">
                <Loader />
              </div>
            )
          ) : (
            <>
              <div className="payout-detail">
                <div className="payout-detail__card">
                  <div className="payout-detail__topbar">
                    <h3 className="payout-detail__topbar-title">Payout Details</h3>
                    <div className="payout-detail__topbar-chips">
                      {renderStatusChip(
                        payoutListData?.status,
                        payoutListData?.status === "COMPLETED"
                          ? "Paid"
                          : payoutListData?.status,
                      )}
                      {payoutListData?.invoice_status &&
                        renderStatusChip(
                          payoutListData?.invoice_status,
                          `Invoice ${payoutListData?.invoice_status}`,
                        )}
                    </div>
                    <div className="payout-detail__topbar-payout">
                      <span className="payout-detail__topbar-payout-label">
                        Final Payout
                      </span>
                      <span className="payout-detail__topbar-payout-value">
                        {formatCurrency(payoutListData?.payout_amount)}
                      </span>
                    </div>
                  </div>

                  <div className="payout-detail__body">
                    <div className="payout-detail__column">
                      <div className="payout-detail__section">
                        <div className="payout-detail__section-title">Invoice</div>
                        <div className="payout-detail__fields">
                          {renderField(
                            "Invoice Number",
                            payoutListData?.invoice_number ||
                              existingInvoiceNumber,
                            { mono: true },
                          )}
                        </div>
                      </div>

                      <div className="payout-detail__section">
                        <div className="payout-detail__section-title">Campaign</div>
                        <div className="payout-detail__fields">
                          {renderField("Campaign Name", contractData?.name)}
                          {renderField(
                            "Type",
                            campaignData?.is_marketplace == 1
                              ? "Marketplace"
                              : campaignData?.is_marketplace == 0
                                ? "InHouse"
                                : "N/A",
                          )}
                          {renderField("Brand", props?.brand_name)}
                          {renderField(
                            "Initiated By",
                            payoutListData?.initiated_by,
                          )}
                        </div>
                      </div>

                      <div className="payout-detail__section">
                        <div className="payout-detail__section-title">Amounts</div>
                        <div className="payout-detail__fields">
                          {renderField(
                            "Contract",
                            formatCurrency(payoutListData?.contract_amount),
                          )}
                          {renderField(
                            "Order",
                            formatCurrency(payoutListData?.order_amount),
                          )}
                          {renderField(
                            "Tax",
                            formatCurrency(payoutListData?.tax_amount),
                          )}
                          {renderField(
                            "Platform Fee",
                            formatCurrency(payoutListData?.platform_charges),
                          )}
                        </div>
                      </div>

                      <div className="payout-detail__section">
                        <div className="payout-detail__section-title">Timeline</div>
                        <div className="payout-detail__fields">
                          {renderField(
                            "Scheduled",
                            payoutListData?.date_scheduled
                              ? Utils.formatDate(payoutListData?.date_scheduled)
                              : null,
                          )}
                          {renderField(
                            "Initiated",
                            payoutListData?.initiated_at
                              ? Utils.formatDate(payoutListData?.initiated_at)
                              : null,
                          )}
                          {renderField(
                            "Completed",
                            payoutListData?.date_completed
                              ? Utils.formatDate(payoutListData?.date_completed)
                              : null,
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="payout-detail__column">
                      <div className="payout-detail__section">
                        <div className="payout-detail__section-title">
                          Influencer
                        </div>
                        <div className="payout-detail__fields payout-detail__fields--single">
                          {renderField(
                            "Name",
                            influencerData?.influencer_data?.name,
                          )}
                          {renderField(
                            "Influencer Id",
                            influencerData?.influencer_data?.influencer_id,
                            { mono: true },
                          )}
                        </div>
                      </div>

                      <div className="payout-detail__section">
                        <div className="payout-detail__section-title">Banking</div>
                        <div className="payout-detail__fields payout-detail__fields--single">
                          {influencerData?.kyc_data?.find(
                            (k) => k?.kyc_type === "TAX_PROOF",
                          )?.kyc_value &&
                            renderField(
                              "Tax Proof",
                              influencerData?.kyc_data?.find(
                                (k) => k?.kyc_type === "TAX_PROOF",
                              )?.kyc_value,
                              { mono: true },
                            )}
                          {renderField(
                            "Account Holder",
                            influencerData?.bank_data?.account_holder_name,
                          )}
                          {renderField(
                            "Account / UPI",
                            influencerData?.bank_data?.account_number,
                            { mono: true },
                          )}
                          {influencerData?.bank_data?.ifsc_code &&
                            renderField(
                              "IFSC",
                              influencerData?.bank_data?.ifsc_code,
                              { mono: true },
                            )}
                        </div>
                      </div>
                    </div>

                    {hasPayoutToken && (
                      <div className="payout-detail__column payout-detail__column--billing">
                        <div className="payout-detail__section">
                          <div className="payout-detail__section-title">
                            Billing
                          </div>
                          <div className="payout-detail__address-grid">
                            {renderPayoutAddressBlock("Billed To")}
                            {renderPayoutAddressBlock("Shipped To")}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="payout-detail__actions">
                    {isAwaitingInvoice && hasPayoutToken && (
                      <span className="payout-detail__status-note">
                        Awaiting invoice from influencer
                      </span>
                    )}

                    {payoutListData?.status == "PENDING" &&
                      !isInvoiceBlockingActions && (
                      <PrimaryCtaInvert
                        borderColor="var(--general-error)"
                        fontSize="font_size_small"
                        height="32px"
                        text="Reject Payout"
                        onClick={openRejectModal}
                        isLoading={false}
                      />
                    )}

                    <PrimaryCta
                      invertSmall
                      fontSize={"font_size_regular"}
                      text={"Contract Details"}
                      onClick={() => contactDetailPage(assignment_id)}
                    />

                    {(isAwaitingInvoice ||
                      invoiceStatus === "SUBMITTED" ||
                      invoiceStatus === "APPROVED" ||
                      invoiceStatus === "ACCEPTED") &&
                      !hasValidPayoutToken && (
                      <PrimaryCta
                        invertSmall
                        fontSize={"font_size_regular"}
                        text={"Generate Invoice"}
                        isLoading={generateInvoiceLoading}
                        onClick={generatePayoutToken}
                      />
                    )}

                    {invoiceStatus === "SUBMITTED" && (
                      <>
                        <PrimaryCta
                          invertSmall
                          fontSize={"font_size_regular"}
                          text={"Preview Invoice"}
                          onClick={openInvoicePreview}
                        />
                        <PrimaryCtaInvert
                          borderColor="var(--general-error)"
                          fontSize="font_size_regular"
                          height="40px"
                          text="Reject"
                          onClick={() => openInvoicePreview({ reject: true })}
                        />
                        <PrimaryCta
                          fifth
                          fontSize={"font_size_regular"}
                          text={"Approve"}
                          isLoading={invoiceReviewLoading}
                          onClick={handleApproveInvoice}
                        />
                      </>
                    )}

                    {canDownloadInvoice && (
                      <PrimaryCta
                        invertSmall
                        fontSize={"font_size_regular"}
                        text={
                          invoiceDownloading
                            ? "Downloading..."
                            : "Download Invoice"
                        }
                        isLoading={invoiceDownloading}
                        onClick={openDownloadModal}
                      />
                    )}

                    {payoutListData?.status == "PENDING" &&
                      !isInvoiceBlockingActions && (
                      <PrimaryCta
                        invertSmall
                        text={"Mark Completed"}
                        onClick={openModalFun}
                      />
                    )}

                    {!isInvoiceBlockingActions && (
                      <PrimaryCta
                        fifth
                        fontSize={"font_size_regular"}
                        style={{
                          cursor:
                            isPayoutCompleted === "COMPLETED" ||
                            isPayoutCompleted === "PAYMENT_INITIATED"
                              ? "not-allowed"
                              : "pointer",
                        }}
                        text={
                          isPayoutCompleted == "COMPLETED"
                            ? "Transfer Completed"
                            : isPayoutCompleted == "PAYMENT_INITIATED"
                              ? "Payment Initiated"
                              : "Initiate Transfer"
                        }
                        disabled={
                          isPayoutCompleted == "COMPLETED" ||
                          isPayoutCompleted == "PAYMENT_INITIATED"
                        }
                        onClick={() => setOpenModal(true)}
                      />
                    )}
                  </div>
                </div>
              </div>

              {/* ---------- api call button ---------- */}

              {modalIsOpen && renderAssignmentSignModal()}
              {rejectModalIsOpen && renderRejectPayoutModal()}
              {invoicePreviewOpen && renderInvoicePreviewModal()}
              <InvoiceDownloadModal
                isOpen={downloadModalVisible}
                onClose={closeDownloadModal}
                isDownloading={invoiceDownloading}
                existingInvoiceNumber={existingInvoiceNumber}
                autoGeneratedInvoiceId={autoGeneratedInvoiceId}
                customInvoiceId={customInvoiceId}
                onCustomInvoiceIdChange={setCustomInvoiceId}
                onDownloadWithExisting={handleDownloadWithExisting}
                onDownloadWithAutoGenerated={handleDownloadWithAutoGenerated}
                onDownloadWithCustom={handleDownloadWithCustom}
              />
              {/*  ----------- Confirmartion modal ---------- */}
              <ModalComponent
                isOpen={openModal}
                onRequestClose={() => setOpenModal(false)}
                customStyle={{
                  overlay: {
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    zIndex: 999999,
                  },
                  content: {
                    top: "50%",
                    left: "50%",
                    right: "auto",
                    bottom: "auto",
                    // borderColor: "#f55879",
                    backgroundColor: "#F0F3F9",

                    marginRight: "-50%",
                    transform: "translate(-50%, -50%)",
                    padding: "20px",
                    borderRadius: "8px",
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.15)",
                  },
                }}
              >
                <div className="">
                  <CustomText
                    h5
                    text={"Are you sure For Initiate Transfer?"}
                    textColor={"text_grey_400_color"}
                    className="m-b-8 typographyBoldH5"
                  />
                </div>

                <div className="modal-btn-center">
                  <PrimaryCta
                    invertSmall
                    onClick={() => setOpenModal(false)}
                    fontSize={"font_size_large"}
                    text={"No"}
                  />

                  <PrimaryCta
                    third
                    fontSize={"font_size_regular"}
                    className="header-credit-right"
                    text={"Yes"}
                    isLoading={effectiveLoad}
                    onClick={() => handleInitateTransfer()}
                  />
                </div>
              </ModalComponent>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default PayoutDetailScreen;
const CancelReminder = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "var(--general-secondary-color)",
    textAlign: "center",
    zIndex: "5",
    height: "20%",
    display: "flex",
    flexDirection: "column",
    minHeight: "200px",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.95)",
    zIndex: 10,
  },
};
